import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";
import { DeleteDialog } from "../components";
import { routes } from "utilities/routing/generatedRoutes";
import ConfirmCopyModal from "components/modals/ConfirmCopyModal";
import { useOpenNewTrainSidePanel } from "components/SidePanel/Train/NewTrainSidePanel";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  trainId: number
}

const TrainOptionsPanel = (props: Props) => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);
  const [isCopying, setIsCopying] = React.useState<boolean>(false);

  const onDelete = async () => {
    await window.CoreApi.Train.DeleteTrain({ trainId: props.trainId });
    window.location.href = props.listUrl;
  };

  const onCopy = async () => {
    const res = await window.CoreApi.Train.CopyTrain({ trainId: props.trainId });
    return res.data;
  };
  const openNewTrainSidePanel = useOpenNewTrainSidePanel();

  return <>
    <GeneralOptionsPanel
      data={props.optionsPanelData}
      links={[
        {
          href: props.listUrl,
          text: RESX.Buttons.ListView,
          visible: true
        }, {
          text: RESX.Flight.AddSegment,
          visible: site.permissions.train.canCreate,
          onClick: () => openNewTrainSidePanel(props.trainId)
        }, {
          text: RESX.Buttons.btnCopy,
          onClick: () => { setIsCopying(true); },
          visible: site.permissions.train.canCreate,
        }, {
          onClick: () => { setIsDeleting(true); },
          text: RESX.Buttons.btnDelete,
          visible: site.permissions.train.canCreate,
        }
      ]}
    />
    <DeleteDialog
      spinForever
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.DeleteSure}
    />
    <ConfirmCopyModal
      isOpen={isCopying}
      apiCall={onCopy}
      onClose={() => { setIsCopying(false); }}
      onSuccess={(itemId) => window.location.href = routes.train_Detail(itemId).absolute}
    />
  </>;
};

export default TrainOptionsPanel;